import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import Home from "@/pages/Home";
import ProjectPage from "@/pages/ProjectPage";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Intro } from "@/components/site/Intro";
import { EASE, scrollToTarget, useSmoothScroll } from "@/lib/motion";

const RouteScroll = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) {
      scrollToTarget(0, true);
      return undefined;
    }
    const t = setTimeout(() => scrollToTarget(hash), 120);
    return () => clearTimeout(t);
  }, [pathname, hash]);
  return null;
};

const Page = ({ children }) => {
  const reduce = useReducedMotion();
  return (
    <motion.main
      id="main"
      initial={reduce ? false : { opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, ease: EASE }}
    >
      {children}
    </motion.main>
  );
};

const Shell = () => {
  const { pathname } = useLocation();
  useSmoothScroll();
  return (
    <>
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[60] focus:bg-ink focus:px-3 focus:py-2 focus:text-paper">
        Skip to content
      </a>
      <Intro />
      <Header />
      <RouteScroll />
      <Page key={pathname}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work/:slug" element={<ProjectPage />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </Page>
      <Footer />
    </>
  );
};

export default function App() {
  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}
